"use client"

import { useEffect, useState } from "react"

async function initMocks() {
  const { worker } = await import("@/mocks/browser")
  await worker.start({ onUnhandledRequest: "warn" }).catch(() => {})
}

export function MSWProvider({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    initMocks().then(() => setReady(true))
  }, [])

  if (!ready) return null

  return <>{children}</>
}
